import {createStyles} from '@material-ui/core';
import * as colors from 'assets/theme/colors';
import type {Theme} from '@material-ui/core/styles';

export default createStyles((theme: Theme) => ({
    root: {
        width: '100%',
        fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
        fontSize: theme.typography.pxToRem(14),
        backgroundColor: `${colors.neutrals.A10} !important`,
        boxShadow: theme.shadows[4],
    },
    header: {
        fontSize: theme.typography.pxToRem(16),
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightBold,
        backgroundColor: `${colors.neutrals.A10} !important`,
    },
    body: {
        padding: 0,
        width: '100%',
        fontFamily: 'Arial, Verdana, Droid Sans, Benton Sans',
        color: theme.palette.secondary.main,
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightRegular,
        backgroundColor: `${colors.neutrals.A10} !important`,
    },
    icon: {
        width: '1rem',
        height: '1rem',
        marginRight: '1rem',
    },
}));
